"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const postUserMatchQuery_1 = __importDefault(require("./postUserMatchQuery"));
const postUserSuggestQuery_1 = __importDefault(require("./postUserSuggestQuery"));
const getUser_1 = __importDefault(require("./getUser"));
const putUser_1 = __importDefault(require("./putUser"));
const createUserClient = (axios) => ({
    postUserMatchQuery: ({ query, timeZone }) => postUserMatchQuery_1.default({ axios, query, timeZone }),
    postUserSuggestQuery: ({ role, search }) => postUserSuggestQuery_1.default({ axios, role, search }),
    getUser: ({ userId }) => getUser_1.default({ axios, userId }),
    putUser: ({ userId, user }) => putUser_1.default({ axios, userId, user })
});
exports.default = createUserClient;
